"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
exports.SHA256_HEADER = "X-Amz-Content-Sha256";
exports.ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
exports.CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
exports.AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
exports.SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
exports.EXPIRES_QUERY_PARAM = "X-Amz-Expires";
exports.HOST_HEADER = "host";
exports.ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";